module.exports = __webpack_public_path__ + "static/media/03_MICS-1.4-ES-8 1.baf08e66.svg";